import { PrivateUserProfileView } from "@bbb/model";
import { _apiRequest, setCsrfToken } from "./_apiClients";

export type WalletAuthChallenge = {
  address: string;
  domain: string;
  nonce: string;
  message: string;
  issuedAt: number;
};

export type WalletAuthResult = {
  profile: PrivateUserProfileView;
  expiresAt: number;
  createdProfile?: boolean;
  csrfToken?: string;
};

export type WalletSessionResult = {
  authenticated: boolean;
  profile: PrivateUserProfileView | null;
  expiresAt?: number;
  csrfToken?: string;
};

export function requestAuthChallenge(payload: {
  address: string;
  domain?: string;
}) {
  return _apiRequest<WalletAuthChallenge>("/v1/auth/challenge", {
    method: "POST",
    data: payload,
    authRequired: false,
  });
}

export function registerWithWallet(payload: {
  address: string;
  nonce: string;
  signature: string;
  domain?: string;
}) {
  return _apiRequest<WalletAuthResult>("/v1/auth/register", {
    method: "POST",
    data: payload,
    authRequired: false,
  }).then(cacheResponseCsrfToken);
}

export function loginWithWallet(payload: {
  address: string;
  nonce: string;
  signature: string;
  domain?: string;
}) {
  return _apiRequest<WalletAuthResult>("/v1/auth/login", {
    method: "POST",
    data: payload,
    authRequired: false,
  }).then(cacheResponseCsrfToken);
}

export function connectWithWallet(payload: {
  address: string;
  nonce: string;
  signature: string;
  domain?: string;
}) {
  return _apiRequest<WalletAuthResult>("/v1/auth/connect", {
    method: "POST",
    data: payload,
    authRequired: false,
  }).then(cacheResponseCsrfToken);
}

export function getWalletSession() {
  return _apiRequest<WalletSessionResult>("/v1/auth/session", {
    authRequired: false,
  }).then(cacheResponseCsrfToken);
}

export function logoutWalletSession() {
  return _apiRequest<{ ok: true }>("/v1/auth/logout", {
    method: "POST",
  }).finally(() => setCsrfToken(null));
}

function cacheResponseCsrfToken<T extends { csrfToken?: string }>(result: T) {
  setCsrfToken(result.csrfToken);
  return result;
}
